import React, {useContext, useEffect, useState} from "react";
import PropTypes from 'prop-types';
import {makeStyles, Drawer, Typography} from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import _ from 'lodash'
import {GeneralInformation} from "./Panels";
import ToolBarActions from "./ToolBarUtils/ToolBarActions";
import CloseDrawerButton from "./ToolBarUtils/CloseDrawerButton";
import {ScreenDesignerContextNew} from "../../../../../../ContextComponents/ScreenDesignerContextNew";
import DragComponents from "./DragComponents";
import ComponentSettings from "./Panels/ComponentSettings";
import {ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary} from "../../../../../../Utils/ExpansionPanel";
import Header from "./Header";
import Divider from "@material-ui/core/Divider";
import OtherComponents from "./Panels/OtherComponents";
import {insert} from "object-path-immutable";
import Navigator from "./ToolBarUtils/Navigator/Navigator";

const drawerWidth = 375;
const useStyles = makeStyles({
    container: {
        display: 'flex',
        position: 'relative'
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        position: 'relative',
    },
    drawerClosed: {
        width: 0,
        flexShrink: 0
    },
    drawerPaper: {
        width: drawerWidth,
        position: "absolute",
    },
    panelsContainer: {
        height: 'calc(100% - 50px)',
        overflowY: 'auto'
    },
});

const panelTypes = {
    general: "general",
    components: "components",
    navigator: "navigator"
};

const ToolBar = () => {
    const classes = useStyles();
    const {
        screenValues: {otherComponents = []},
        selectedComponent,
        setSelectedComponent
    } = useContext(ScreenDesignerContextNew);
    const [open, setOpen] = useState(true);
    const [panels, setPanels] = useState([
        {label: 'General Information', name: 'general', component: <GeneralInformation/>, open: false},
        {label: "Component Settings", name: 'settings', component: <ComponentSettings/>, open: false}
    ]);
    const [panelType, setPanelType] = useState('general');


    useEffect(() => {

        //if entity is present, add entity panel
        if (otherComponents.length) {
            if (panelType === panelTypes.components) {
                setPanelType(panelTypes.general);
                setSelectedComponent({
                    component: otherComponents[otherComponents.length - 1],
                    path: `otherComponents.${otherComponents.length - 1}`
                });
                setTimeout(() => {
                    if (otherComponents[otherComponents.length - 1].type === 'context') {
                        const contextBtn = document.getElementById("contextDesignerBtn");
                        contextBtn && contextBtn.click();
                    }
                }, 300)
            }
        }
        if (otherComponents.length && panels[1].label !== 'Other Components') {
            const entityTab = {
                label: 'Other Components',
                name: 'otherComponents',
                component: <OtherComponents/>,
                open: true
            };
            let newPanels = insert(panels, '', entityTab, 1)
            setPanels(newPanels);
            return
        }

        //if entity.length = 0, remove entity Panel
        if (!otherComponents.length && panels[1].label === 'Other Components') {
            const filteredPanels = panels.filter(i => i.label !== 'Other Components');
            setPanels(filteredPanels);
        }


    }, [otherComponents.length]);

    useEffect(() => {
        if (!selectedComponent) return
        changeComponentTabLabel(selectedComponent);
        const settingIndex = _.findIndex(panels, (p) => p.name === 'settings');
        if (selectedComponent) {
            //if toolbar is closed, toggle

            if (panelType === panelTypes.components) {
                setPanelType(panelTypes.general)
            }

            if (!open) {
                toggleDrawer()
            }
            //if panel componentSettings is closed, toggle
            if (!panels[settingIndex].open) {
                togglePanels(settingIndex)
            }
        }
    }, [JSON.stringify(selectedComponent)]);


    function toggleDrawer() {
        setOpen(open => !open)
    }

    function togglePanels(index) {
        const newPanels = panels.slice();
        newPanels[index].open = !newPanels[index].open;
        setPanels(newPanels)
    }

    function changeComponentTabLabel(selectedComponent) {
        const {component: {type} = {}} = selectedComponent || {};
        const newPanels = panels.slice();
        const settingIndex = _.findIndex(panels, (p) => p.name === 'settings');
        newPanels[settingIndex].label = type ? `${type} Settings` : 'Component Settings';
        setPanels(newPanels);
    }

    return (
        <div className={classes.container}>
            <Drawer
                open={open}
                variant="persistent"
                className={open ? classes.drawer : classes.drawerClosed}
                classes={{paper: classes.drawerPaper}}
            >
                <div className={classes.panelsContainer}>
                    <Header panelType={panelType} setPanelType={setPanelType}/>
                    {panelType === panelTypes.general ? (
                        panels.map((panel, i) => {
                            return (
                                <ExpansionPanel
                                    expanded={panel.open}
                                    onClick={() => togglePanels(i)}
                                    key={i}
                                >
                                    <ExpansionPanelSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                    >
                                        <Typography style={{textTransform: "capitalize"}}>{panel.label}</Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails
                                        classes={{root: classes.panelDetails}}
                                        onClick={e => e.stopPropagation()}
                                    >
                                        {panel.component}
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            )
                        })
                    ) : panelType === panelTypes.components ? (
                        <>
                            <Divider/>
                            <DragComponents/>
                        </>
                    ) : panelType === panelTypes.navigator && (
                        <Navigator
                            setPanelType={setPanelType}
                        />
                    )}
                </div>
                <ToolBarActions/>
            </Drawer>
            <CloseDrawerButton
                open={open}
                toggleDrawer={toggleDrawer}
            />
        </div>
    )
};

export default ToolBar;

ToolBar.propTypes = {
    onSaveScreen: PropTypes.func,
    onRemoveScreen: PropTypes.func,
    onCloseScreen: PropTypes.func,
    screenValues: PropTypes.object,
    designerType: PropTypes.string
};